module.exports = __webpack_public_path__ + "media/components/Influencers/Sessions/arrow-5e1c86b5c4d25d011399eef5fa8b2fd7.svg";